import Button from './button';

export default (props) => {
    const { children } = props;

    return <Button { ...props } className={`button--empty ${props.className}`} icon={null}>{ children }</Button>
}